import { getScribeHttpClients } from '@heidi/api/client';
const http = () => getScribeHttpClients().scribeHttpV2;

const BASE_PATH = '/projects/experience-feedback';

export interface CreateWorkExperienceFeedbackRequest {
  ease_stars: number;
  usefulness_stars: number;
  feedback?: string;
  stars?: number;
}

export interface CreateWorkExperienceFeedbackResponse {
  success: boolean;
  feedback_id: string;
  work_general_feedback_count: number;
}

export interface SnoozeWorkExperienceFeedbackResponse {
  success: boolean;
  snooze_count: number;
}

export async function submitWorkExperienceFeedback(
  request: CreateWorkExperienceFeedbackRequest
): Promise<CreateWorkExperienceFeedbackResponse> {
  const response = await http().post<CreateWorkExperienceFeedbackResponse>(
    BASE_PATH,
    request
  );
  return response.data;
}

export async function snoozeWorkExperienceFeedback(): Promise<SnoozeWorkExperienceFeedbackResponse> {
  const response = await http().post<SnoozeWorkExperienceFeedbackResponse>(
    `${BASE_PATH}/snooze`
  );
  return response.data;
}
